import { Dialog } from 'primereact/dialog';
import React, {useEffect} from 'react';

const SubscriptionMessageModal = ({
  subscriptionMessageModalVisible,
  setSubscriptionMessageModalVisible,
  messageText,
  onClose,
}) => {
  useEffect(() => {
    if (subscriptionMessageModalVisible) {
      // const timer = setTimeout(() => {
        setSubscriptionMessageModalVisible(false);
      // }, 2000);

      // return () => clearTimeout(timer); // Clear the timer if the component unmounts or modalVisible changes
    }
  }, [subscriptionMessageModalVisible, setSubscriptionMessageModalVisible]);

  
  const handleModalClose = () => {
    setSubscriptionMessageModalVisible(!subscriptionMessageModalVisible);
  };
  return (
    <div className="flex justify-content-center">
    <Dialog
      modal
        visible={subscriptionMessageModalVisible}
      style={{ width: "50vw" }}
      onHide={() => {
        if (!subscriptionMessageModalVisible) return;
        handleModalClose();
      }}
      content={({ hide }) => (
        <div
            className="flex flex-column px-4 py-3 gap-4"
            style={{
              borderRadius: "12px",
              backgroundImage:
                "radial-gradient(circle at left top, #ffffff, #ffffff)",
            }}
          >
          <div className="flex justify-content-center align-items-center gap-2">
            
              <img
                src={'Laundy_App_Icons_Gifs/SettingIcons/gift.png'}
                style={{
                  width: 35,
                height: 35
                }}
              />
            <p className=" text-xl font-semibold text-center" style={{ color:"#1752AA"}}>
              {messageText}
            </p>
            
            <div style={{ position: "absolute", right: 3, top: 3, cursor:"pointer" }} onClick={() => handleModalClose()}>
              <img
                src={'images/Cross.jpeg'}
                style={{
                  width: 25,
                  height: 25
                }}
              />
            </div>
          </div>
        </div>
      )}
      ></Dialog>
    </div>
  );
};

export default SubscriptionMessageModal;
